module.exports = __webpack_public_path__ + "media/win.13110898.wav";